interface tokenAction {
  type: string;
  token: string | null;
}

export default function tokenReducer(
  token: string | null,
  action: tokenAction,
) {
  switch (action.type) {
    case "changed": {
      return action.token;
    }
    case "deleted": {
      return null;
    }
    default: {
      throw Error("Unknown action: " + action.type);
    }
  }
}
